<template>
  <div class="notify-message" :class="notifyMessageContent.type + ' ' + className">
    <span class="material-symbols-outlined">
      {{ icons_types[notifyMessageContent.type] }}
    </span>
    <div class="d-flex justify-content-between">
      <div class="title">{{ notifyMessageContent.title }}</div>
      <button @click="sendErrorDump(notifyMessageContent.data)"
        class="btn btn-filled-white color-danger hover-color-danger minw-auto btn-sm pl_-10 pr_-10 ml_-24"
        v-if="notifyMessageContent.type == 'error' && notifyMessageContent.data">
        {{ dump_error_id ? 'Hata Bildirildi' : 'Hata Bildir' }}
      </button>
    </div>
    <div class="message" v-if="notifyMessageContent.message" v-html="notifyMessageContent.message.detail"></div>
    <div class="dump-code mt_-20" v-if="dump_error_id">
      Hata bildirim kodunuz: {{ dump_error_id }}. Lütfen bu kodu saklayınız bu kod ile destek
      alabilirsiniz.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dump_error_id: '',
      icons_types: {
        error: 'error',
        success: 'check_circle',
        warning: 'warning',
        info: 'info',
      },
    };
  },
  props: {
    notifyMessageContent: {},
    className: '',
  },
  methods: {
    sendErrorDump(data) {
      this.$axios.post('api/error-dump/', { error_dump: data }).then(response => {
        this.dump_error_id = response.data.error_id;
      });
    },
    closeNotifyMessageBox() {
      this.$emit('closeNotifyMessageBox');
    },
  },
};
</script>
